import { useRef, useState } from 'react'
import { FormHelperText } from '@mui/material'
import { BaseFeedbackConIcona, BasePopoverConfermaOperazione } from 'feedback'
import { FeedbackCaricamentoFileMultipli } from 'files'
import { BaseButtons } from 'inputs'
import { creaRegoleValidazioneFile } from 'inputs/validazione/RegoleCustom'
import { BaseScatola, BaseGridLayout, useModal, BaseModal } from 'layout'
import { BaseGrassetto, BaseTesto, BaseTitolo } from 'text'
import { creaAcceptString, creaLabelListaMimeTypes, flattenMimeTypesList, generaUUID } from 'utils'

export default function BaseSceltaImmaginiMultiple(props) {
  const {
    onSalva,
    onAnnulla,
    useGestioneFile,
    calcolaAltreInfoPerUpload,
    propsFileInput: {
      tipiFileAccettati = [],
      dimensioneMaxInMegabyte,
      ...restPropsFileInput
    }
  } = props

  const fileInputRef = useRef()

  const tipiFileAccettatiDefinitivi = flattenMimeTypesList(tipiFileAccettati)
  const { messaggi, validate } = creaRegoleValidazioneFile(tipiFileAccettatiDefinitivi, dimensioneMaxInMegabyte)
  const labelTipiFileAccettati = creaLabelListaMimeTypes(tipiFileAccettatiDefinitivi)

  const [fileCaricati, setFileCaricati] = useState([])

  function aggiungiNuoviFile(nuoviFile) {
    setFileCaricati(fileEsistenti => {
      const nomiFileEsistenti = fileEsistenti.map(({ name }) => name)
      nuoviFile.forEach(file => {
        file.uuid = generaUUID()
        file.url = window.URL.createObjectURL(file)
        const errors = []
        Object.entries(validate).forEach(([nome, funzione]) => {
          const validazioneOk = funzione([file])
          if (!validazioneOk) {
            errors.push({ key: nome, msg: messaggi[nome] })
          }
        })
        if (nomiFileEsistenti.includes(file.name)) {
          errors.push({ key: 'duplicato', msg: 'È già presente un altro file con lo stesso nome' })
        }
        file.errors = errors
      })
      return [...fileEsistenti, ...nuoviFile]
    })
  }

  function pulisciUrl(url) {
    setTimeout(() => window.URL.revokeObjectURL(url), 500)
  }

  function eliminaFile(uuidFile) {
    setFileCaricati(fileEsistenti => fileEsistenti.filter(({ uuid }) => uuid !== uuidFile))
  }

  function eliminaTuttiFile() {
    setFileCaricati([])
  }

  const fileConErrori = fileCaricati.filter(({ errors }) => errors.length > 0)
  const ciSonoErrori = fileConErrori.length > 0
  const feedbackErrori = ciSonoErrori && (
    <BaseFeedbackConIcona.Errore messaggio={`${fileConErrori.length} immagini non valide`} />
  )

  const { modalRef, openModal, closeModal } = useModal()

  function salva(fileCaricatiSulServer) {
    onSalva(fileCaricatiSulServer.map(({ uuid, name, type }) => ({
      uuid,
      filename: name,
      mimetype: type
    })))
    closeModal()
  }

  return (
    <>
      {labelTipiFileAccettati &&
        <FormHelperText style={{ textAlign: 'center' }}>
          Formati di immagine validi:
          <BaseGrassetto>{` ${labelTipiFileAccettati}`}</BaseGrassetto>
        </FormHelperText>
      }

      {dimensioneMaxInMegabyte !== undefined &&
        <FormHelperText style={{ textAlign: 'center' }}>
          Dimensione massima consentita per immagine:
          <BaseGrassetto>{` ${dimensioneMaxInMegabyte} MB`}</BaseGrassetto>
        </FormHelperText>
      }

      <BaseButtons.CaricaFile
        testo='Carica immagini'
        onClick={() => fileInputRef.current.click()}
        sx={{ mb: 4 }}
      />

      <input
        type='file'
        multiple
        accept={creaAcceptString(tipiFileAccettatiDefinitivi)}
        hidden
        ref={fileInputRef}
        onChange={e => aggiungiNuoviFile(Array.from(e.target.files))}
        {...restPropsFileInput}
      />

      <BaseGridLayout alignCenter justifyCenter spacing={4}>
        <BaseTitolo colorato>
          Immagini caricate ({fileCaricati.length})
        </BaseTitolo>
        {feedbackErrori}
      </BaseGridLayout>

      <BaseGridLayout alignCenter justifyContent='space-evenly'>
        {fileCaricati.map(({ uuid, url, name, errors }) =>
          <BaseScatola
            outlined
            sx={{ ...(errors.length > 0 && { borderColor: 'error.main' }) }}
            key={uuid}
          >
            <img
              src={url}
              onLoad={() => pulisciUrl(url)}
              style={{ maxHeight: 200 }}
            />
            <br />
            <BaseTesto piccolo>{name}</BaseTesto>

            {errors.map(({ key, msg }) =>
              <FormHelperText
                error
                style={{ textAlign: 'center' }}
                key={key}
              >
                {msg}
              </FormHelperText>
            )}

            <BaseButtons.Elimina
              variant='outlined'
              onClick={() => eliminaFile(uuid)}
            />
          </BaseScatola>
        )}
      </BaseGridLayout>

      {fileCaricati.length > 0 &&
        <BaseGridLayout alignCenter justifyCenter sx={{ mt: 2 }}>
          <>
            <BaseButtons.Conferma
              testo='Conferma caricamento'
              onClick={openModal}
              {...(ciSonoErrori && { disabled: true })}
            />
            {feedbackErrori}

            <BaseModal
              ref={modalRef}
              titolo='Esecuzione caricamento'
              disabilitaChiusuraCliccandoFuori
              nascondiBottoneChiudi
            >
              <FeedbackCaricamentoFileMultipli
                fileDaCaricare={fileCaricati}
                onFileCaricati={salva}
                useGestioneFile={useGestioneFile}
                calcolaAltreInfoPerUpload={calcolaAltreInfoPerUpload}
              />
            </BaseModal>
          </>

          <BaseButtons.Annulla
            testo='Annulla e chiudi'
            color='default'
            onClick={onAnnulla}
          />

          <BasePopoverConfermaOperazione
            messaggio='Eliminare tutte le immagini?'
            onConferma={eliminaTuttiFile}
          >
            <BaseButtons.Elimina
              testo='Elimina tutte'
              variant='outlined'
            />
          </BasePopoverConfermaOperazione>
        </BaseGridLayout>
      }
    </>
  )
}